import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Percentage-point movement with an explicit sign, e.g. 3.1 → "+3.1%".
 * Computed averages can come out negative, so the sign can't be hardcoded.
 */
export function formatSignedPercent(value: number): string {
  return `${value > 0 ? "+" : ""}${value.toFixed(1)}%`;
}

/** ISO date or timestamp → "MM/DD/YY" — the mockup's compact date format. */
export function formatShortDate(iso: string): string {
  const [yyyy, mm, dd] = iso.slice(0, 10).split("-");
  return `${mm}/${dd}/${yyyy?.slice(2)}`;
}

/** MM/DD/YY HH:mm in the viewer's local timezone (email log entries). */
export function formatShortDateTime(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${String(d.getFullYear()).slice(2)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
